import * as React from 'react';
import isBrowser from '../services/isBrowser';

export const useElementSize = ({ref, el, useHeight, defaultValue} : {ref?: any, el?: HTMLElement, useHeight?: boolean, defaultValue?: number}): number => {
    let resizeTimeout: any = null;
    const [size, setSize] = React.useState(defaultValue || null);
    const onResize = () => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(() => {
            if (!isBrowser()) return;
            let size = null;
            if (!ref && !el) {
                size = useHeight ? window.innerHeight : window.innerWidth;
            }
            if (ref?.current || el) {
                let activeElement = ref?.current || el;

                if (useHeight) {
                    size = Math.min(window.innerHeight - 16, activeElement.offsetHeight);
                }
                else {
                    size = Math.min(window.innerWidth - 16, activeElement.offsetWidth);
                }
            }
            setSize(size);
        }, 20)

    }
    React.useEffect(() => {
        if (!isBrowser()) return;
        onResize();
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize);
            if (resizeTimeout) clearTimeout(resizeTimeout);
        }
    })
    return size;
}